module.exports = __webpack_public_path__ + "img/1492959226.4df6457c.jpg";